"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var date_ext_1 = require("./date-ext");
var number_ext_1 = require("./number-ext");
function initializeCulture(culture) {
    if (typeof culture !== 'undefined') {
        culture.toFullDate = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.dateFormats.full);
        };
        culture.toLongDate = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.dateFormats.long);
        };
        culture.toMediumDate = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.dateFormats.medium);
        };
        culture.toShortDate = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.dateFormats.short);
        };
        culture.toUniversalDate = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.dateFormats.universal);
        };
        culture.toFullTime = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.timeFormats.full);
        };
        culture.toLongTime = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.timeFormats.long);
        };
        culture.toMediumTime = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.timeFormats.medium);
        };
        culture.toShortTime = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.timeFormats.short);
        };
        culture.toUniversalTime = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.timeFormats.universal);
        };
        culture.toFullDateTime = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.dateTimeFormats.full);
        };
        culture.toLongDateTime = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.dateTimeFormats.long);
        };
        culture.toMediumDateTime = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.dateTimeFormats.medium);
        };
        culture.toShortDateTime = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.dateTimeFormats.short);
        };
        culture.toUniversalDateTime = function (date) {
            return date_ext_1.DateExt.toFormattedString(culture, date, culture.dateTimeFormats.universal);
        };
        culture.formatDate = function (date, format) {
            return date_ext_1.DateExt.toFormattedString(culture, date, format);
        };
        culture.parseDate = function (value, formats) {
            return date_ext_1.DateExt.parse(culture, value, formats);
        };
        culture.toNumber = function (number, round) {
            return number_ext_1.NumberExt.format(culture, number, culture.number.decimal, types_1.NumberFormatType.Number, round);
        };
        culture.toShortNumber = function (number, round) {
            return number_ext_1.NumberExt.format(culture, number, culture.number.narrow, types_1.NumberFormatType.Short, round);
        };
        culture.toPercentNumber = function (number, round) {
            return number_ext_1.NumberExt.format(culture, number, culture.number.percent, types_1.NumberFormatType.Percent, round);
        };
        culture.formatNumber = function (number, format, type, round) {
            return number_ext_1.NumberExt.format(culture, number, format, type, round);
        };
        culture.parseNumber = function (value) {
            return number_ext_1.NumberExt.parse(culture, value);
        };
    }
}
exports.initializeCulture = initializeCulture;
//# sourceMappingURL=utilities.js.map


//////////////////
// WEBPACK FOOTER
// ../player-globalization/utilities.js
// module id = 254
// module chunks = 0 1